export default {
    DEVELOPMENT: {
        apiKey: 'AIzaSyDBpYKWXbTckO3UkfooNrsVAWYxPYkgU2o',
        authDomain: 'is-core-web-intg.firebaseapp.com',
        projectId: 'is-core-web-intg',
        storageBucket: 'is-core-web-intg.appspot.com',
        messagingSenderId: '358862215131',
        appId: '1:358862215131:web:8aa4bfa761f3fd03bbf9fe',
    },

    STAGING: {
        apiKey: 'AIzaSyCNZg_AD095bbaFosZU9ULRPkHvFal0CjQ',
        authDomain: 'is-core-web-stge.firebaseapp.com',
        projectId: 'is-core-web-stge',
        storageBucket: 'is-core-web-stge.appspot.com',
        messagingSenderId: '393466387324',
        appId: '1:393466387324:web:931c63c111b4152d15a2f9',
    },

    PRODUCTION: {
        apiKey: 'AIzaSyBNnRSE4i7r2E6mvcEdrgm_kKFgywgotHc',
        authDomain: 'is-core-web-prod.firebaseapp.com',
        projectId: 'is-core-web-prod',
        storageBucket: 'is-core-web-prod.appspot.com',
        messagingSenderId: '189571757653',
        appId: '1:189571757653:web:2d5c8e74b9ea7cff0646dc',
    },
};
